import { useQuery } from "@tanstack/vue-query";
import { Ref } from "vue";

import { ConsumptionQueryKeys } from "@/data/api/kili/consumption/consumption-query-keys";
import KiliApi from "@/data/api/kili/kili-api";

export function useGetSiteConsumptionInfosQuery(siteId: Ref<number>) {
  return useQuery({
    queryKey: ConsumptionQueryKeys.siteConsumptionInformations(siteId),
    queryFn: () =>
      KiliApi.getSiteConsumptionInformations({
        params: { siteId: siteId.value },
      }),
  });
}
